import StatusDepositContent from './Content';
import StatusDepositProvider from './context';

const Deposit: React.FunctionComponent = function () {
  return (
    <StatusDepositProvider>
      <StatusDepositContent />
    </StatusDepositProvider>
  );
};

export default Deposit;
